import React from 'react';
import { useOutletContext } from 'react-router-dom';
import SearchResult from '../components/SearchResult';

const SearchResultPage = () => {
  const { searchState } = useOutletContext();

  return <SearchResult searchState={searchState} />;
};

export default SearchResultPage;
